// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"65e49984","119":"ad7482cc","160":"46eba63e","580":"f74d3465","657":"b0576faa","999":"06f7eb18"}[chunkId] + ".chunk.css";
};